import {ref, watch} from 'vue'
import Autocomplete from "@/setup/Autocomplete";
import {comuneManager, nazioneManager, provinciaManager} from "../api/Citta";

export function ProvinciaComuneAutocomplete(provinciaAutocomplete: any, comuneAutocomplete: any) {
    const disableWatcher = ref(false)
    watch(
        provinciaAutocomplete.selection,
        (new_value)=>{
            comuneAutocomplete.addAjaxParam('provincia', new_value?.id)
            if(!disableWatcher.value){
                // questo controllo mi serve per evitare che se carico prima il comune dela provincia in fase di
                // caricamento iniziale non me lo svuota quando carica la provincia
                if(comuneAutocomplete.selection.value?.provincia_id != new_value?.id){
                    //in questo caso vuol dire che ho un comune e che il comune non è della provincia selezionata
                    comuneAutocomplete.emptyAll()
                }
            }
        }
    )

    return {
        disableWatcher:disableWatcher
    }
}

export function ProvinciaComune(){
    const na = Autocomplete(nazioneManager)
    const pa = Autocomplete(provinciaManager)
    const ca = Autocomplete(comuneManager)

    const isNazioneItalia = ref(false)

    watch(
        na.selection,
        (new_value)=>{
            isNazioneItalia.value = false
            if(new_value){
                isNazioneItalia.value = new_value.codice.toString().toLowerCase() == 'ita'
            }
        }
    )

    const pc = ProvinciaComuneAutocomplete(pa, ca)
    return {
        disableProvinciaWatcher: pc.disableWatcher,
        isNazioneItalia: isNazioneItalia,
        pa_isLoading: pa.isLoading,
        pa_options: pa.options,
        pa_selection: pa.selection,
        pa_search: pa.search,
        pa_retrieve: pa.retrieve,
        pa_add: pa.add,
        pa_empty: pa.empty,

        ca_isLoading: ca.isLoading,
        ca_options: ca.options,
        ca_selection: ca.selection,
        ca_search: ca.search,
        ca_retrieve: ca.retrieve,
        ca_add: ca.add,
        ca_empty: ca.empty,

        na_isLoading: na.isLoading,
        na_options: na.options,
        na_selection: na.selection,
        na_search: na.search,
        na_retrieve: na.retrieve,
        na_add: na.add,
        na_empty: na.empty,
    }
}
